import React, { useState, useEffect } from "react";
import "./homeV1.css";

import NavbarV1 from "./NavbarV1";
import HeroV1 from "./HeroV1";
import CategoriesV1 from "./CategoriesV1";
import TrendingV1 from "./TrendingV1";
import ExploreAustraliaV1 from "./ExploreAustraliaV1";
import CorporateV1 from "./CorporateV1";
import SoloTravelersV1 from "./SoloTravelersV1";
import CraftedV1 from "./CraftedV1";
import BlogStoriesV1 from "./BlogStoriesV1";
import StatsTrustV1 from "./StatsTrustV1";
import FooterV1 from "./FooterV1";
import LoginModal from "../Users/LoginModal";

function HomeV1() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loginType, setLoginType] = useState(1); // 1 = user, 2 = host

  useEffect(() => {
    document.title = "Weyfarin | A Destination for Lived Experiences";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleOpenLogin = () => {
    setLoginType(1);
    setLoginModalOpen(true);
  };

  const handleOpenSignup = () => {
    setLoginType(1);
    setLoginModalOpen(true);
  };

  return (
    <div className="home-v1-wrapper">
      {/* Redesigned Figma Navbar */}
      <NavbarV1
        onOpenLogin={handleOpenLogin}
        onOpenSignup={handleOpenSignup}
      />

      {/* Hero Section with Drone Beach Image, Overlay, Search Bar & Badges */}
      <HeroV1 />

      {/* Category Tabs / Tablist */}
      <CategoriesV1
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
      />

      {/* Section 1: Trending Experiences Carousel */}
      <TrendingV1 selectedCategory={selectedCategory} />

      {/* Section 2: Explore Australia Experiences (Dark Theme) */}
      <ExploreAustraliaV1 />

      {/* Section 3: Corporate Experiences (Client Spotlight & Testimonial) */}
      <CorporateV1 />

      {/* Section 4: Solo Travelers Banner (Glassmorphism feature cards) */}
      <SoloTravelersV1 />

      {/* Section 5: Weyfarin Crafted Experiences Collection */}
      <CraftedV1 />

      {/* Section 6: Travel Stories & Guides (Blog) */}
      <BlogStoriesV1 />

      {/* Section 7: Statistics / Trust Numbers Bar */}
      <StatsTrustV1 />

      {/* Footer */}
      <FooterV1 />

      {/* Auth Modal Integration */}
      <LoginModal
        isOpen={loginModalOpen}
        onClose={() => setLoginModalOpen(false)}
        userType={loginType}
      />
    </div>
  );
}

export default HomeV1;
